// Single source of truth for the homepage FAQ content. Used both by the
// rendered FAQ accordion and the FAQPage JSON-LD on the homepage so
// the visible Q&A and the structured-data Q&A never drift apart.

export type FAQItem = { q: string; a: string };

export const FAQS: FAQItem[] = [
  {
    q: "Where does our data go?",
    a: "MLX connects read-only to the systems you approve and keeps each target scoped to your organisation. Those source systems remain authoritative. When a workflow uses an external model provider, the context needed for that request follows the provider path approved for your deployment.",
  },
  {
    q: "Do we need to migrate our legacy systems first?",
    a: "No wholesale or rip-and-replace migration is required. A focused activation connects the priority systems you approve, starting read-only, and brings the relevant evidence into the Twin while those systems remain authoritative. Mercury Labs engineers then work with your experts to turn that evidence into reviewed business context.",
  },
  {
    q: "Can we choose models and control their cost?",
    a: "Yes. The approved business context stays separate from the model provider. You can use stronger models for demanding work, lower-cost models for routine tasks or evaluate another configured provider without rebuilding that context. Material changes are tested before rollout.",
  },
  {
    q: "What does this cost?",
    a: "MLX is a scoped engagement. Mercury Labs engineers support the activation and operate the configured target, while model usage is recorded where provider evidence is available. Talk to us for a proposal based on the systems, workflows and operating requirements in scope.",
  },
  {
    q: "Why not just use ChatGPT or Copilot?",
    a: "Use them where they fit. The Twin gives approved AI tools the reviewed business context they normally lack, including agreed definitions, source freshness and evidence about what each answer used. It complements the AI surface rather than replacing it.",
  },
  {
    q: "We're regulated. Can we actually use this?",
    a: "MLX starts scoped to your organisation and read-only, with human review before business context is published. Normal governed queries do not include browser, terminal or write access. A regulated deployment still requires approval of the exact data and model paths, evidence retention and operating controls.",
  },
  {
    q: "Which systems can you connect?",
    a: "Current connectors: Xero, SunSystems, Stripe, GoCardless, Microsoft 365 and SharePoint, Google Drive, Docs and Sheets, Gmail, Google Calendar, Outlook, Slack, Microsoft Teams, Granola, Notion, Linear and GitHub. Legacy ledgers such as Infor SunSystems stay queryable without migration; exact scope is confirmed before activation.",
  },
  {
    q: "What happens when the Twin cannot support a question?",
    a: "It says so. A governed answer identifies the approved product, version and freshness it used. If that product does not support the requested question or evidence, the Twin returns 'not supported' instead of producing a plausible guess.",
  },
];
